"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withTheme = _interopRequireDefault(require("./withTheme"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = (0, _withTheme.default)(() => /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20 16C17.7909 16 16 17.7909 16 20V76C16 78.2091 17.7909 80 20 80H24V52C24 49.7909 25.7909 48 28 48H68C70.2091 48 72 49.7909 72 52V80H76C78.2091 80 80 78.2091 80 76V33.6569L62.3431 16H32V28H60C62.2091 28 64 29.7909 64 32C64 34.2091 62.2091 36 60 36H28C25.7909 36 24 34.2091 24 32V16H20ZM28 8H20C13.3726 8 8 13.3726 8 20V76C8 82.6274 13.3726 88 20 88H28H68H76C82.6274 88 88 82.6274 88 76V32C88 30.9391 87.5786 29.9217 86.8284 29.1716L66.8284 9.17157C66.0783 8.42143 65.0609 8 64 8H28ZM32 56V80H64V56H32Z"
}), '0 0 96 96');